import { google } from 'streem-sdk-protobuf';

export const convertProtobufToSeconds = (time: google.protobuf.ITimestamp): number => {
    return time?.seconds?.low || 0 + (time?.nanos || 0) / 1000000000;
};

export function getReservationExpirationMessage(minutesToDisplay: number): string {
    return `This reservation will expire in ${minutesToDisplay < 1 ? 'less than ' : ''}${
        minutesToDisplay < 1 ? 1 : minutesToDisplay
    } minute${minutesToDisplay > 1 ? 's' : ''}.`;
}

export const ACTIVE_MODAL_MESSAGES = {
    UPDATE_AVAILABILITY_STATUS: `It looks like you've been away for a while. Would you like to update your
                    availability status?`,
    BAD_NETWORK_STATUS:
        'Due to bad network connectivity, we have changed your status to Not Ready.',
};
